import React, { useState, useEffect } from 'react';
import { FiSearch, FiEdit, FiToggleLeft, FiToggleRight, FiEye, FiEyeOff, FiCheck, FiX, FiFileText, FiFile, FiUsers, FiMapPin, FiCalendar, FiRefreshCw, FiFilter, FiChevronDown, FiChevronUp, FiArrowUp, FiArrowDown, FiMoreVertical, FiSettings, FiShield, FiAward, FiTrendingUp, FiActivity, FiBarChart2, FiPieChart, FiTarget, FiZap, FiClock, FiAlertCircle, FiGlobe, FiPhone, FiMail, FiStar, FiCreditCard, FiPackage, FiShoppingCart, FiDollarSign, FiTrendingDown, FiDownload, FiUpload, FiEdit2, FiTrash2, FiEye2, FiPlus, FiMinus, FiChevronRight, FiChevronLeft, FiHome, FiTruck, FiNavigation, FiUser, FiCheckCircle, FiXCircle } from 'react-icons/fi';
import api from '../../utils/api';
import toast from 'react-hot-toast';


const PendingVendors = () => {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalVendors, setTotalVendors] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showDocsModal, setShowDocsModal] = useState(false);
  const [selectedVendorDocs, setSelectedVendorDocs] = useState(null);
  const [ownerExists, setOwnerExists] = useState(false);
  const [showOwnerForm, setShowOwnerForm] = useState(false);
  const [ownerData, setOwnerData] = useState({
      name: '',
      password: '',
      contactNumber: ''
  });
  const [showPassword, setShowPassword] = useState(false);

  const isPDF = (url) => {
    if (!url) return false;
    return url.toLowerCase().includes('.pdf') || url.toLowerCase().includes('pdf');
  };

  const isWordDoc = (url) => {
    if (!url) return false;
    return url.toLowerCase().includes('.doc') || url.toLowerCase().includes('.docx');
  };

  const isExcelDoc = (url) => {
    if (!url) return false;
    return url.toLowerCase().includes('.xls') || url.toLowerCase().includes('.xlsx');
  };

  const isTextDoc = (url) => {
    if (!url) return false;
    return url.toLowerCase().includes('.txt');
  };

  const isDocument = (url) => {
    return isPDF(url) || isWordDoc(url) || isExcelDoc(url) || isTextDoc(url);
  };

  const getDocumentIcon = (url) => {
    if (isPDF(url)) return { icon: '📄', label: 'PDF Document', color: '#dc3545' };
    if (isWordDoc(url)) return { icon: '📝', label: 'Word Document', color: '#2b579a' };
    if (isExcelDoc(url)) return { icon: '📊', label: 'Excel Document', color: '#217346' };
    if (isTextDoc(url)) return { icon: '📃', label: 'Text Document', color: '#6c757d' };
    return { icon: '📎', label: 'Document', color: '#6c757d' };
  };

  const openInNewTab = (url) => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  useEffect(() => {
    fetchPendingVendors();
  }, [currentPage, itemsPerPage]);

  const viewVendorDocuments = (vendor) => {
    setSelectedVendorDocs(vendor);
    setShowDocsModal(true);
  };

   const createOwner = async (vendorId) => {
    if (!ownerData.name || !ownerData.password || !ownerData.contactNumber) {
      toast.error('Please fill all owner details');
      return;
    }

    try {
      const response = await api.post(`/superadmin/vendors/${vendorId}/create-owner`, ownerData);
      if (response.data.success) {
        toast.success('Owner created and vendor approved successfully!');
        setShowOwnerForm(false);
        setOwnerData({ name: '', password: '', contactNumber: '' });
        setShowModal(false);
        fetchPendingVendors();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to create owner');
    }
  };

  const fetchPendingVendors = async (isManualRefresh = false) => {
    try {
      const params = {
        page: currentPage,
        limit: itemsPerPage
      };

      if (isManualRefresh) {
        setRefreshing(true);
        toast.loading('Refreshing pending vendors...', { id: 'refresh' });
      }

      console.log('Fetching pending vendors with params:', params);
      const response = await api.get('/superadmin/vendors/pending', { params });
      console.log('Pending vendors response:', response.data);
      
      if (response.data.success) {
        setVendors(response.data.data);
        setTotalPages(response.data.totalPages || 1);
        setTotalVendors(response.data.total || 0);
        
        // Show success message for manual refresh
        if (isManualRefresh) {
          toast.success(`Refreshed! Found ${response.data.data.length} pending vendors`, { id: 'refresh' });
        }
      } else {
        toast.error('Failed to load pending vendors data', { id: 'refresh' });
      }
    } catch (error) {
      console.error('Fetch pending vendors error:', error);
      toast.error(`Failed to fetch pending vendors: ${error.response?.data?.message || error.message}`, { id: 'refresh' });
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  const approveVendor = async (vendorId) => {
    try {
      const response = await api.post(`/superadmin/vendors/${vendorId}/approve`, {
        ownerPassword: 'Vendor@123'
      });
      if (response.data.success) {
        toast.success('Vendor approved successfully');
        setShowModal(false);
        fetchPendingVendors();
      }
    } catch (error) {
      toast.error('Failed to approve vendor');
    }
  };

  const rejectVendor = async (vendorId) => {
    try {
      const response = await api.post(`/superadmin/vendors/${vendorId}/reject`, {
        reason: 'Does not meet requirements'
      });
      if (response.data.success) {
        toast.success('Vendor rejected');
        setShowModal(false)
        fetchPendingVendors();
      }
    } catch (error) {
      toast.error('Failed to reject vendor');
    }
  };

  const viewVendorDetails = async (vendor) => {
    setSelectedVendor(vendor);
    setShowModal(true);
    setOwnerData({ name: vendor.personalDetails.name, password: '', contactNumber: vendor.personalDetails.contactNumber });
    
    // Check if owner exists for this email
    if (vendor.approvalStatus === 'pending') {
      try {
        const response = await api.get('/superadmin/vendors/check-owner', {
          params: { email: vendor.personalDetails.email }
        });
        setOwnerExists(response.data.ownerExists);
      } catch (error) {
        console.error('Failed to check owner:', error);
      }
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex items-center justify-center">
        <div className="text-center">
          <div className="relative inline-flex items-center justify-center">
            <div className="w-20 h-20 border-4 border-indigo-200 rounded-full"></div>
            <div className="w-20 h-20 border-4 border-indigo-600 rounded-full animate-spin absolute border-t-transparent"></div>
          </div>
          <p className="mt-4 text-gray-600 font-medium">Loading Pending Vendors...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-3">
                <div className="w-10 h-10 bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl flex items-center justify-center">
                  <FiUsers className="text-white text-xl" />
                </div>
                Pending Vendor Approvals
              </h1>
              <p className="text-gray-600 mt-1">Review and approve vendor applications</p>
            </div>
            
            <div className="flex items-center gap-3">
              <div className="px-4 py-2 bg-amber-100 text-amber-800 rounded-full text-sm font-semibold flex items-center gap-2">
                <FiAlertCircle className="text-amber-600" />
                {vendors.length} Pending
              </div>
              <button
                onClick={() => fetchPendingVendors(true)}
                disabled={refreshing}
                className="flex items-center gap-2 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
              >
                <FiRefreshCw className={`text-sm ${refreshing ? 'animate-spin' : ''}`} />
                <span className="text-sm font-medium">{refreshing ? 'Refreshing...' : 'Refresh'}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Vendors Table */}
        <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Restaurant Name</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Owner Name</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Email</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Contact</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">City</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Location</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Applied On</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {vendors.map(vendor => (
                  <tr key={vendor._id} className="hover:bg-gray-50 transition-colors duration-150">
                    <td className="px-6 py-4 font-medium text-gray-900">{vendor.restaurantDetails.restaurantName}</td>
                    <td className="px-6 py-4 text-gray-700">{vendor.personalDetails.name}</td>
                    <td className="px-6 py-4 text-gray-700">{vendor.personalDetails.email}</td>
                    <td className="px-6 py-4 text-gray-700">{vendor.personalDetails.contactNumber}</td>
                    <td className="px-6 py-4 text-gray-700">{vendor.restaurantDetails.city}</td>
                    <td className="px-6 py-4 text-xs">
                      <div className="space-y-1">
                        <div>
                          <span className="text-gray-600 font-semibold">Lat:</span>{' '}
                          <span className="text-blue-600 font-mono">
                            {vendor.restaurantDetails.location?.coordinates[1].toFixed(6)}
                          </span>
                        </div>
                        <div>
                          <span className="text-gray-600 font-semibold">Lng:</span>{' '}
                          <span className="text-green-600 font-mono">
                            {vendor.restaurantDetails.location?.coordinates[0].toFixed(6)}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-gray-700">{new Date(vendor.createdAt).toLocaleDateString()}</td>
                    <td className="px-6 py-4">
                      <div className="flex flex-col gap-2">
                        <button 
                          onClick={() => viewVendorDetails(vendor)}
                          className="px-3 py-1 bg-blue-500 text-white rounded text-sm font-medium hover:bg-blue-600 transition-colors duration-200"
                        >
                          View
                        </button>
                        <button 
                          onClick={() => viewVendorDocuments(vendor)}
                          className="px-3 py-1 bg-purple-500 text-white rounded text-sm font-medium hover:bg-purple-600 transition-colors duration-200"
                        >
                          Documents
                        </button>
                        <button 
                          onClick={() => rejectVendor(vendor._id)}
                          className="px-3 py-1 bg-red-500 text-white rounded text-sm font-medium hover:bg-red-600 transition-colors duration-200"
                        >
                          Reject
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {vendors.length === 0 && (
          <div className="text-center py-12">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <FiFileText className="text-gray-400 text-2xl" />
            </div>
            <p className="text-gray-500">No pending vendors</p>
          </div>
        )}
      </div>

        {/* Pagination */}
      {totalPages > 1 && (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mt-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div className="text-sm text-gray-600">
              Showing {vendors.length} of {totalVendors} pending vendors
            </div>
            <div className="flex gap-2 items-center">
              <button
                onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                disabled={currentPage === 1}
                className="px-3 py-2 bg-gray-500 text-white rounded-lg text-sm font-medium hover:bg-gray-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors duration-200"
              >
                Previous
              </button>
              {[...Array(totalPages)].map((_, idx) => {
                const pageNum = idx + 1;
                if (
                  pageNum === 1 ||
                  pageNum === totalPages ||
                  (pageNum >= currentPage - 1 && pageNum <= currentPage + 1)
                ) {
                  return (
                    <button
                      key={pageNum}
                      onClick={() => setCurrentPage(pageNum)}
                      className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${
                        pageNum === currentPage 
                          ? 'bg-purple-500 text-white' 
                          : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                      }`}
                    >
                      {pageNum}
                    </button>
                  );
                } else if (pageNum === currentPage - 2 || pageNum === currentPage + 2) {
                  return <span key={pageNum} className="px-2 text-gray-500">...</span>;
                }
                return null;
              })}
              <button
                onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                disabled={currentPage === totalPages}
                className="px-3 py-2 bg-gray-500 text-white rounded-lg text-sm font-medium hover:bg-gray-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors duration-200"
              >
                Next
              </button>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <span className="text-gray-600">Show</span>
              <select
                value={itemsPerPage}
                onChange={(e) => {
                  setItemsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
                className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
              <span className="text-gray-600">per page</span>
            </div>
          </div>
        </div>
      )}

      {/* Vendor Details Modal */}
      {showModal && selectedVendor && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-xl max-w-4xl w-full mx-4 max-h-[90vh] overflow-auto" onClick={(e) => e.stopPropagation()}>
            <div className="p-6 border-b border-gray-200 flex justify-between items-center">
              <h2 className="text-2xl font-bold text-gray-900">Vendor Details</h2>
              <button 
                onClick={() => setShowModal(false)}
                className="text-gray-500 hover:text-gray-700 transition-colors duration-200"
              >
                <FiX size={24} />
              </button>
            </div>
            
            <div className="p-6 space-y-6">
              {/* Personal Details */}
              <div className="bg-gray-50 rounded-lg p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Personal Details</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Name:</label>
                    <span className="text-gray-900">{selectedVendor.personalDetails.name}</span>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Email:</label>
                    <span className="text-gray-900">{selectedVendor.personalDetails.email}</span>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Username:</label>
                    <span className="text-gray-900">{selectedVendor.ownerCredentials.username}</span>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Contact:</label>
                    <span className="text-gray-900">{selectedVendor.personalDetails.contactNumber}</span>
                  </div>
                  {selectedVendor.personalDetails.identityCard && (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Identity Card:</label>
                      <span className="text-gray-900">{selectedVendor.personalDetails.identityCard}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Restaurant Details */}
              <div className="bg-gray-50 rounded-lg p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Restaurant Details</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Restaurant Name:</label>
                    <span className="text-gray-900">{selectedVendor.restaurantDetails.restaurantName}</span>
                  </div>
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Address:</label>
                    <span className="text-gray-900">{selectedVendor.restaurantDetails.city}, {selectedVendor.restaurantDetails.address}</span>
                  </div>
                  {selectedVendor.restaurantDetails.fssaiNumber && (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">FSSAI Number:</label>
                      <span className="text-gray-900">{selectedVendor.restaurantDetails.fssaiNumber}</span>
                    </div>
                  )}
                  {selectedVendor.restaurantDetails.gstNumber && (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">GST Number:</label>
                      <span className="text-gray-900">{selectedVendor.restaurantDetails.gstNumber}</span>
                    </div>
                  )}
                  {selectedVendor.restaurantDetails.location && (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Location:</label>
                      <span className="text-gray-900">
                        Lat: {selectedVendor.restaurantDetails.location.coordinates[1]}, 
                        Long: {selectedVendor.restaurantDetails.location.coordinates[0]}
                      </span>
                    </div>
                  )}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Registered On:</label>
                    <span className="text-gray-900">{new Date(selectedVendor.createdAt).toLocaleDateString()}</span>
                  </div>
                </div>
              </div>

              {/* Status */}
              <div className="bg-gray-50 rounded-lg p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Status</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Approval Status:</label>
                    <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                      selectedVendor.approvalStatus === 'approved' ? 'bg-green-100 text-green-800' : 
                      selectedVendor.approvalStatus === 'pending' ? 'bg-amber-100 text-amber-800' : 
                      'bg-red-100 text-red-800'
                    }`}>
                      {selectedVendor.approvalStatus.charAt(0).toUpperCase() + selectedVendor.approvalStatus.slice(1)}
                    </span>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Active Status:</label>
                    <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                      selectedVendor.isActive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                    }`}>
                      {selectedVendor.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
      
                  {/* Owner Creation Form */}
            {selectedVendor.approvalStatus === 'pending' && !ownerExists && showOwnerForm && (
              <div className="bg-amber-50 rounded-lg p-6">
                <h3 className="text-lg font-semibold text-amber-800 mb-2">Create Vendor Owner</h3>
                <p className="text-sm text-amber-700 mb-4">
                  This is the first vendor with email <strong>{selectedVendor.personalDetails.email}</strong>. 
                  Please create an owner account to manage all vendors under this email.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-amber-800 mb-1">Owner Name *</label>
                    <input
                      type="text"
                      value={ownerData.name}
                      onChange={(e) => setOwnerData({...ownerData, name: e.target.value})}
                      placeholder="Enter owner name"
                      className="w-full px-4 py-2 border border-amber-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-amber-800 mb-1">Contact Number *</label>
                    <input
                      type="text"
                      value={ownerData.contactNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, '');
                        if (value.length <= 10) {
                          setOwnerData({...ownerData, contactNumber: value});
                        }
                      }}
                      placeholder="10-digit number"
                      pattern="[0-9]{10}"
                      maxLength="10"
                      className="w-full px-4 py-2 border border-amber-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-amber-800 mb-1">Password *</label>
                    <div className="relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        value={ownerData.password}
                        onChange={(e) => setOwnerData({...ownerData, password: e.target.value})}
                        placeholder="Enter password"
                        required
                        className="w-full px-4 py-2 pr-12 border border-amber-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-amber-600 hover:text-amber-800"
                      >
                        {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Modal Footer */}
            <div className="p-6 border-t border-gray-200 flex flex-wrap gap-3">
              {selectedVendor.approvalStatus === 'pending' && (
                <>
                  {!ownerExists && !showOwnerForm ? (
                    <button 
                      onClick={() => setShowOwnerForm(true)}
                      className="px-4 py-2 bg-amber-500 text-white rounded-lg font-medium hover:bg-amber-600 transition-colors duration-200"
                    >
                      Create Owner & Approve
                    </button>
                  ) : !ownerExists && showOwnerForm ? (
                    <>
                      <button 
                        onClick={() => createOwner(selectedVendor._id)}
                        className="px-4 py-2 bg-green-500 text-white rounded-lg font-medium hover:bg-green-600 transition-colors duration-200"
                      >
                        <FiCheck /> Create Owner & Approve
                      </button>
                      <button 
                        onClick={() => setShowOwnerForm(false)}
                        className="px-4 py-2 bg-gray-500 text-white rounded-lg font-medium hover:bg-gray-600 transition-colors duration-200"
                      >
                        Cancel
                      </button>
                    </>
                  ) : (
                    <button 
                      onClick={() => approveVendor(selectedVendor._id)}
                      className="px-4 py-2 bg-green-500 text-white rounded-lg font-medium hover:bg-green-600 transition-colors duration-200"
                    >
                      <FiCheck /> Approve (Owner Exists)
                    </button>
                  )}
                  <button 
                    onClick={() => rejectVendor(selectedVendor._id)}
                    className="px-4 py-2 bg-red-500 text-white rounded-lg font-medium hover:bg-red-600 transition-colors duration-200"
                  >
                    <FiX /> Reject
                  </button>
                </>
              )}
              {selectedVendor.approvalStatus === 'rejected' && (
                <>
                  <button 
                    onClick={() => approveVendor(selectedVendor._id)}
                    className="px-4 py-2 bg-green-500 text-white rounded-lg font-medium hover:bg-green-600 transition-colors duration-200"
                  >
                    <FiCheck /> Re-Approve
                  </button>
                  <div className="px-3 py-2 bg-amber-100 rounded-lg text-sm text-amber-800">
                    This vendor was previously rejected. You can re-approve if needed.
                  </div>
                </>
              )}
              {selectedVendor.approvalStatus === 'approved' && (
                <>
                  <button 
                    className={`px-4 py-2 rounded-lg font-medium transition-colors duration-200 ${
                      selectedVendor.isActive 
                        ? 'bg-amber-500 text-white hover:bg-amber-600' 
                        : 'bg-green-500 text-white hover:bg-green-600'
                    }`}
                    onClick={() => setShowModal(false)}
                  >
                    {selectedVendor.isActive ? <FiToggleRight /> : <FiToggleLeft />}
                    {selectedVendor.isActive ? 'Deactivate' : 'Activate'}
                  </button>
                  <button 
                    onClick={() => rejectVendor(selectedVendor._id)}
                    className="px-4 py-2 bg-red-500 text-white rounded-lg font-medium hover:bg-red-600 transition-colors duration-200"
                  >
                    <FiX /> Reject
                  </button>
                </>
              )}
              <button 
                onClick={() => setShowModal(false)}
                className="px-4 py-2 bg-gray-500 text-white rounded-lg font-medium hover:bg-gray-600 transition-colors duration-200"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Documents Modal */}
      {showDocsModal && selectedVendorDocs && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-xl max-w-5xl w-full mx-4 max-h-[90vh] overflow-auto" onClick={(e) => e.stopPropagation()}>
            <div className="p-6 border-b border-gray-200 flex justify-between items-center">
              <h2 className="text-2xl font-bold text-gray-900">Vendor Documents - {selectedVendorDocs.restaurantDetails.restaurantName}</h2>
              <button 
                onClick={() => setShowDocsModal(false)}
                className="text-gray-500 hover:text-gray-700 transition-colors duration-200"
              >
                <FiX size={24} />
              </button>
            </div>
            
            <div className="p-6">
              <div className="bg-gray-50 rounded-lg p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Restaurant Documents</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                  {/* FSSAI Certificate */}
                  <div className="text-center">
                    <h4 className="mb-3 text-sm font-medium text-gray-700">FSSAI Certificate</h4>
                    {selectedVendorDocs.documents?.fssaiCertificate ? (
                      <div 
                        onClick={() => openInNewTab(selectedVendorDocs.documents.fssaiCertificate)}
                        className="w-full h-48 rounded-lg border-2 border-gray-300 cursor-pointer flex items-center justify-center bg-gray-50 hover:bg-gray-100 transition-all duration-200 hover:scale-105"
                        style={{
                          backgroundImage: isDocument(selectedVendorDocs.documents.fssaiCertificate) 
                            ? 'none' 
                            : `url(${selectedVendorDocs.documents.fssaiCertificate})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          backgroundColor: isDocument(selectedVendorDocs.documents.fssaiCertificate) ? '#f8f9fa' : 'transparent'
                        }}
                      >
                        {isDocument(selectedVendorDocs.documents.fssaiCertificate) && (
                          <div className="text-center" style={{ color: getDocumentIcon(selectedVendorDocs.documents.fssaiCertificate).color }}>
                            <div className="text-5xl mb-2">{getDocumentIcon(selectedVendorDocs.documents.fssaiCertificate).icon}</div>
                            <div className="text-sm font-bold">{getDocumentIcon(selectedVendorDocs.documents.fssaiCertificate).label}</div>
                            <div className="text-xs text-gray-600 mt-1">Click to view</div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="w-full h-48 bg-gray-100 rounded-lg border-2 border-dashed border-gray-300 flex flex-col items-center justify-center text-gray-500">
                        <FiFileText size={40} className="mb-2" />
                        <span>Not Uploaded</span>
                      </div>
                    )}
                  </div>

                  {/* GST Certificate */}
                  <div className="text-center">
                    <h4 className="mb-3 text-sm font-medium text-gray-700">GST Certificate</h4>
                    {selectedVendorDocs.documents?.gstCertificate ? (
                      <div 
                        onClick={() => openInNewTab(selectedVendorDocs.documents.gstCertificate)}
                        className="w-full h-48 rounded-lg border-2 border-gray-300 cursor-pointer flex items-center justify-center bg-gray-50 hover:bg-gray-100 transition-all duration-200 hover:scale-105"
                        style={{
                          backgroundImage: isDocument(selectedVendorDocs.documents.gstCertificate) 
                            ? 'none' 
                            : `url(${selectedVendorDocs.documents.gstCertificate})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          backgroundColor: isDocument(selectedVendorDocs.documents.gstCertificate) ? '#f8f9fa' : 'transparent'
                        }}
                      >
                        {isDocument(selectedVendorDocs.documents.gstCertificate) && (
                          <div className="text-center" style={{ color: getDocumentIcon(selectedVendorDocs.documents.gstCertificate).color }}>
                            <div className="text-5xl mb-2">{getDocumentIcon(selectedVendorDocs.documents.gstCertificate).icon}</div>
                            <div className="text-sm font-bold">{getDocumentIcon(selectedVendorDocs.documents.gstCertificate).label}</div>
                            <div className="text-xs text-gray-600 mt-1">Click to view</div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="w-full h-48 bg-gray-100 rounded-lg border-2 border-dashed border-gray-300 flex flex-col items-center justify-center text-gray-500">
                        <FiFileText size={40} className="mb-2" />
                        <span>Not Uploaded</span>
                      </div>
                    )}
                  </div>

                  {/* Trade License */}
                  <div className="text-center">
                    <h4 className="mb-3 text-sm font-medium text-gray-700">Trade License</h4>
                    {selectedVendorDocs.documents?.tradeLicense ? (
                      <div 
                        onClick={() => openInNewTab(selectedVendorDocs.documents.tradeLicense)}
                        className="w-full h-48 rounded-lg border-2 border-gray-300 cursor-pointer flex items-center justify-center bg-gray-50 hover:bg-gray-100 transition-all duration-200 hover:scale-105"
                        style={{
                          backgroundImage: isDocument(selectedVendorDocs.documents.tradeLicense) 
                            ? 'none' 
                            : `url(${selectedVendorDocs.documents.tradeLicense})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          backgroundColor: isDocument(selectedVendorDocs.documents.tradeLicense) ? '#f8f9fa' : 'transparent'
                        }}
                      >
                        {isDocument(selectedVendorDocs.documents.tradeLicense) && (
                          <div className="text-center" style={{ color: getDocumentIcon(selectedVendorDocs.documents.tradeLicense).color }}>
                            <div className="text-5xl mb-2">{getDocumentIcon(selectedVendorDocs.documents.tradeLicense).icon}</div>
                            <div className="text-sm font-bold">{getDocumentIcon(selectedVendorDocs.documents.tradeLicense).label}</div>
                            <div className="text-xs text-gray-600 mt-1">Click to view</div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="w-full h-48 bg-gray-100 rounded-lg border-2 border-dashed border-gray-300 flex flex-col items-center justify-center text-gray-500">
                        <FiFileText size={40} className="mb-2" />
                        <span>Not Uploaded</span>
                      </div>
                    )}
                  </div>

                  {/* Restaurant Logo */}
                  <div className="text-center">
                    <h4 className="mb-3 text-sm font-medium text-gray-700">Restaurant Logo</h4>
                    {selectedVendorDocs.documents?.restaurantLogo ? (
                      <div 
                        onClick={() => openInNewTab(selectedVendorDocs.documents.restaurantLogo)}
                        className="w-full h-48 rounded-lg border-2 border-gray-300 cursor-pointer flex items-center justify-center bg-gray-50 hover:bg-gray-100 transition-all duration-200 hover:scale-105"
                        style={{
                          backgroundImage: isDocument(selectedVendorDocs.documents.restaurantLogo) 
                            ? 'none' 
                            : `url(${selectedVendorDocs.documents.restaurantLogo})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          backgroundColor: isDocument(selectedVendorDocs.documents.restaurantLogo) ? '#f8f9fa' : 'transparent'
                        }}
                      >
                        {isDocument(selectedVendorDocs.documents.restaurantLogo) && (
                          <div className="text-center" style={{ color: getDocumentIcon(selectedVendorDocs.documents.restaurantLogo).color }}>
                            <div className="text-5xl mb-2">{getDocumentIcon(selectedVendorDocs.documents.restaurantLogo).icon}</div>
                            <div className="text-sm font-bold">{getDocumentIcon(selectedVendorDocs.documents.restaurantLogo).label}</div>
                            <div className="text-xs text-gray-600 mt-1">Click to view</div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="w-full h-48 bg-gray-100 rounded-lg border-2 border-dashed border-gray-300 flex flex-col items-center justify-center text-gray-500">
                        <FiFileText size={40} className="mb-2" />
                        <span>Not Uploaded</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="p-6 border-t border-gray-200">
              <button 
                onClick={() => setShowDocsModal(false)}
                className="w-full px-4 py-3 bg-gray-500 text-white rounded-lg font-medium hover:bg-gray-600 transition-colors duration-200"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PendingVendors;
